import Tile from 'ol/layer/Tile'
import XYZ from 'ol/source/XYZ'
import Layers from 'utils/mapUtils/ILayers'

class _OSMRoadMap extends Layers {
    constructor() {
        super()
        this.layer = this.createLayer()
    }


    createLayer() {
        return new Tile({
            source: new XYZ({
                url: 'http://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}',
            }),
            zIndex: -100,
        })
    }

    getLayer() {
        return this.layer
    }
}

export default function OSMRoadMap(...args) {
    return new _OSMRoadMap(...args)
}
